import { render, staticRenderFns } from "./getSystem2.vue?vue&type=template&id=00649514&scoped=true&"
import script from "./getSystem2.vue?vue&type=script&lang=js&"
export * from "./getSystem2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00649514",
  null
  
)

export default component.exports